import { render, staticRenderFns } from "./SubmitForApproval.vue?vue&type=template&id=caeeefae&scoped=true"
import script from "./SubmitForApproval.vue?vue&type=script&lang=js"
export * from "./SubmitForApproval.vue?vue&type=script&lang=js"
import style0 from "./SubmitForApproval.vue?vue&type=style&index=0&id=caeeefae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeeefae",
  null
  
)

export default component.exports